import { combineReducers } from 'redux';
import ChainsReducer from './ChainsReducer';
import RestaurantsReducer from './RestaurantsReducer';
import OrderCenterReducer from './OrderCenterReducer';
import OrdersSubscriptionsReducer from './OrdersSubscriptionsReducer';
import MenuReducer from './MenuReducer';
import DeliveryReducer from './DeliveryReducer';
import ConfigReducer from './ConfigReducer';
import KiosksReducer from './KiosksReducer';
import WebsiteReducer from './WebsiteReducer';
import ReportsReducer from './ReportsReducer';
import BrandsReducer from './BrandsReducer';
import { SET_CURRENT_RESTAURANT, SET_CURRENT_CHAIN_ID } from '../../actions/types';
import MarketingCampaignsReducer from './MarketingCampaignsReducer';

const rootReducer = combineReducers({
    chains: ChainsReducer,
    restaurants: RestaurantsReducer,
    orderCenter: OrderCenterReducer,
    orderSubscriptions: OrdersSubscriptionsReducer,
    menu: MenuReducer,
    delivery: DeliveryReducer,
    config: ConfigReducer,
    kiosks: KiosksReducer,
    website: WebsiteReducer,
    brands: BrandsReducer,
    reports: ReportsReducer,
    marketingCampaigns: MarketingCampaignsReducer,
    restaurantId: (state = null) => state,
    chainId: (state = null) => state,
});

export default (state, action) => {
    switch (action.type) {
        case SET_CURRENT_RESTAURANT:
            if (state.restaurantId === action.payload) {
                return rootReducer(state, action);
            }
            return rootReducer({ chains: state.chains, restaurants: state.restaurants, restaurantId: action.payload }, action);
        case SET_CURRENT_CHAIN_ID:
            if (state.chainId === action.payload) {
                return rootReducer(state, action);
            }
            return rootReducer({ chains: state.chains, restaurants: state.restaurants, chainId: action.payload }, action);
        default:
            return rootReducer(state, action);
    }
};